import React, { useEffect, useState } from "react";
import "./Carusel.css";
import { Button, MobileStepper } from "@material-ui/core";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import SwipeableViews from "react-swipeable-views";
import Skeleton from "../../Helpers/Skeleton";
import ReactImageMagnify from "react-image-magnify";
/**
 * Componente que muestra un carrete de imagenes de manera
 * horizontal con un navedador en la parte inferior en caso de ser más de una imagen
 * 
 * @param {Object} props - Propiedades
 * @param {boolean} props.loading - bandera para el estado de carga
 * @param {Array<Object>} [props.imagenes = []] - Lista de imagenes
 * 
 * @category Votación
 * @version 1.2.0
 * @author Ing. Roberto Alonso De la Garza Mendoza
 */
function Carusel({ loading, imagenes = [] }) {
  /**
   * Hook para manipular la posición del carrete
   */
  const [step, setStep] = useState(0);
  /**
   * Avanza una posición hacia adelante el carrete
   */
  const handleNext = () => {
    setStep((prevStep) => prevStep + 1);
  };
  /**
   * Valida si no ha imagenes y setea la posición del carrete a cero
   */
  useEffect(() => {
    if (imagenes.length) {
      setStep(0);
    }
  }, [imagenes]);
  /**
   * Retrocede una posición el carrete
   */
  const handleBack = () => {
    setStep((prevStep) => prevStep - 1);
  };
  /**
   * Asigna la posición del carrete si este fue usado a traves de gestos
   * @param {number} step - La posición del carrete
   */
  const handleSwip = (step) => {
    setStep(step);
  };
  return (
    <div className="Carusel">
      <div id="zoomed" className="zoomed"></div>
      {loading ? (
        <div>
          <Skeleton marginTop="3rem" />
          <Skeleton marginTop="1rem" height="200px" />
        </div>
      ) : null}
      <SwipeableViews
        index={step}
        enableMouseEvents
        axis="x"
        onChangeIndex={handleSwip}
      >
        {imagenes.map((imagen, index) => (
          <div key={imagen.id}>
            {/* <Typography variant="h6" align="center">{imagen.descripcion}</Typography> */}
            <div style={{ display: "flex" }}>
              <ReactImageMagnify
                {...{
                  enlargedImagePortalId: "zoomed",
                  enlargedImageContainerDimensions: {
                    width: "100%",
                    height: "100%",
                  },
                  smallImage: {
                    alt: `imagen_${index + 1}`,
                    isFluidWidth: true,
                    src: imagen.url,
                  },
                  largeImage: {
                    src: imagen.url,
                    width: 1200,
                    height: 1800,
                  },
                }}
              />
              {/* <img
                src={imagen.url}
                className="img-responsive"
                alt="grafico"
              ></img> */}
            </div>
          </div>
        ))}
      </SwipeableViews>
      {imagenes.length >= 2 ? (
        <MobileStepper
          className="stepper-carusel"
          variant="dots"
          steps={imagenes.length}
          position="static"
          activeStep={step}
          nextButton={
            <Button
              data-testid="btn-next-img"
              onClick={handleNext}
              variant="text"
              color="primary"
              disabled={step === imagenes.length - 1}
            >
              <KeyboardArrowRight />
            </Button>
          }
          backButton={
            <Button
              onClick={handleBack}
              variant="text"
              color="primary"
              disabled={imagenes.length ? step === 0 : true}
            >
              <KeyboardArrowLeft />
            </Button>
          }
        ></MobileStepper>
      ) : null}
    </div>
  );
}

export default Carusel;
